<template>
	<div class="chargeAmount mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">充电金额管理</div>
		</div>
		<div class="mainBot disBetween">
			<div class="contentLeft">
				<!-- 社区板块 -->
				<amountDispose ref="amountDispose" @moduleZero="moduleZero"></amountDispose>
			</div>
			<div class="contentRight">
				<!-- 充电站板块 -->
				<chargeStandardDispose ref="chargeStandardDispose" :disposeList="disposeList"></chargeStandardDispose>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import amountDispose from "./amountDispose/amountDispose.vue"
	import chargeStandardDispose from "./chargeStandardDispose/chargeStandardDispose.vue"
	export default {
		name: "chargeAmount",
		components: {
			amountDispose,
			chargeStandardDispose,
		},
		data() {
			return {
				disposeList: [],
			}
		},
		mounted() {
		},
		methods: {
			
			moduleZero(arr){
				this.$set(this,"disposeList",JSON.parse(JSON.stringify(arr)))
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargeAmount.scss";
</style>
